import { useOAIQuery } from '~/hooks/reactQuery';

const isValidBusinessId = (businessId: string) => {
  return !Number.isNaN(Number(businessId)); // datadog businessId NaN 에러 방지
  // businessId !== INITIAL_BUSINESS_PUBLIC_ID // 초기값일때도 API enabled 만들어야함 (MKPC-2053)
};

export const usePlacementPopups = (businessId: string, placement?: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/popups',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      placement,
    },
  });
};

export const usePlacementBanners = (businessId: string, placement: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/banners',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      placement,
    },
  });
};

export const usePlacementEvents = (businessId: string, placement: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/events',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      placement,
    },
  });
};

/**
 * GNB 조회
 * */
export const usePlacementCategory = (businessId: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/navigation-bars-new',
    variables: {
      businessId: Number(businessId),
    },
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
  });
};

/**
 * 카테고리 리스트 전체 조회
 * */
export const usePlacementCategoryTree = (businessId: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/display-categories',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
  });
};

/**
 * 하위 카테고리 조회 API
 * */
export const usePlacementCategoryChildren = (parentId: number) => {
  return useOAIQuery({
    queryKey:
      '/api/market-place/v1/display-categories/{displayCategoryId}/descendants',
    variables: {
      displayCategoryId: parentId,
    },
    queryOptions: {
      keepPreviousData: true,
    },
  });
};

export const usePlacementECouponNavigation = (
  businessId: string,
  type: 'category' | 'brand',
) => {
  return useOAIQuery({
    queryKey: `/api/market-place/v1/placements/e-coupon/${type}`,
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
    },
  });
};

export const usePlacementECouponCategory = (businessId: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/e-coupon/category',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
    },
  });
};

export const usePlacementECouponBrand = (businessId: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/e-coupon/brand',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
    },
  });
};

export const usePlacementShowcases = (
  businessId: string,
  placement: string,
) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/showcases',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      placement,
    },
  });
};

export const usePlacementShowcaseTopBanners = (
  businessId: string,
  placement: string,
) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/showcase-top-banners',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      placement,
    },
  });
};

export const usePlacementSearchTopBanners = (businessId: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/search-top-banners',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
    },
  });
};

export const usePlacementSearchKeywords = (
  businessId: string,
  placement: string,
) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/search-keywords',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      placement,
    },
  });
};

/**
 * @description 홈화면 입점사 쇼케이스 & 쇼케이스 그룹 목록 조회
 * */
export const usePlacementHomeShowcases = (businessId: string) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/placements/home-top-showcases',
    queryOptions: {
      enabled: isValidBusinessId(businessId),
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
    },
  });
};
